import React from "react";
import { Button } from "./ui/button";
import { Mail, Phone, MapPin } from "lucide-react";

const Contact = () => {
  return (
    <section id="contact" className="section-padding">
      <div className="container">
        <div className="contact-grid">
          <div className="contact-content">
            <h2 className="section-heading">Let's start the conversation</h2>
            <p className="section-text mb-8">
              Whether you're building a team or your career, we're ready when you are.
            </p>
            
            <div className="contact-details">
              <div className="contact-item contact-preferred">
                <Mail className="contact-icon" />
                <div>
                  <div className="contact-label-wrapper">
                    <h3 className="contact-label">Email</h3>
                    <span className="preferred-badge">Preferred</span>
                  </div>
                  <a 
                    href="mailto:info@prodigybrains.com.au" 
                    className="contact-value"
                  >
                    info@prodigybrains.com.au
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <Phone className="contact-icon" />
                <div>
                  <h3 className="contact-label">Phone</h3>
                  <a 
                    href="tel:+61410949058" 
                    className="contact-value"
                  >
                    +61 410 949 058
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <MapPin className="contact-icon" />
                <div>
                  <h3 className="contact-label">Locations</h3>
                  <span className="contact-value">Canberra, Sydney, Melbourne & Brisbane</span>
                </div>
              </div>
            </div>

            <div className="contact-button">
              <Button 
                size="lg" 
                className="btn-primary"
                onClick={() => window.location.href = 'mailto:info@prodigybrains.com.au'}
              >
                Email us
              </Button>
            </div>
          </div>
          
          <div className="contact-image">
            <img 
              src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzU4MDg5NzczfDA&ixlib=rb-4.1.0&q=85"
              alt="Enterprise data center with modern server infrastructure"
              className="section-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
